import React, { Component } from 'react';
import Countdown from 'react-countdown-now';
import StringUtils from '../../_utils/StringUtils';

import LoginForm from '../login_form/LoginForm';
import TokenClient from '../../_clients/TokenClient';

import './SessionInfo.css';

const ANONYM_USER = 'Not Logged In';
const SESSION_REFRESH_CHECK_OFFSET = 5000;

class SessionInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userName: ANONYM_USER,
      logged: false,
      sessionAccessToken: null,
      sessionRefreshToken: null,
      sessionExpirationDate: Date.now()
    }

    this._tokenClient = new TokenClient(process.env);

    this.login = this.login.bind(this);
    this.logout = this.logout.bind(this);
    this.showLoginForm = this.showLoginForm.bind(this);
    this.hideLoginForm = this.hideLoginForm.bind(this);
    this._handleLoginClick = this._handleLoginClick.bind(this);
    this._handleLogoutClick = this._handleLogoutClick.bind(this);
    this._handleLoginFormSubmit = this._handleLoginFormSubmit.bind(this);
    this._handleSessionExpiration = this._handleSessionExpiration.bind(this);
  }

  get userName() {
    return this.state.userName;
  }

  get logged() {
    return this.state.logged;
  }

  get accessToken() {
    return this.state.sessionAccessToken;
  }

  login(userName, token, expirationDate, refreshToken) {
    this.setState({
      userName: userName,
      logged: true,
      sessionAccessToken: token,
      sessionRefreshToken: refreshToken,
      sessionExpirationDate: expirationDate
    });

    if (this.props.onLogin != null) {
      let event = new Event('login');
      event.detail = {
          userName: userName,
          token: token,
          expirationDate: expirationDate
      };

      this.props.onLogin(event);
    }
  }

  logout() {
    this.setState({
      userName: ANONYM_USER,
      logged: false,
      sessionAccessToken: null,
      sessionRefreshToken: null,
      sessionExpirationDate: Date.now()
    });

    if (this.props.onLogout != null) {
      this.props.onLogout();
    }
  }

  showLoginForm() {
    this._loginForm.show();
  }

  hideLoginForm() {
    this._loginForm.hide();
  }

  _handleLoginClick(event) {
    this.showLoginForm();
  }

  _handleLogoutClick(event) {
    this.logout();
  }

  _handleLoginFormSubmit(event) {
    const { userName, password } = event.detail;
    const callback = (response) => {
      this.login(userName, 
        response['access_token'], 
        Date.now() + (response['expires_in'] * 100) - SESSION_REFRESH_CHECK_OFFSET, 
        response['refresh_token']);
    }

    this._tokenClient.generateToken(userName, password)
      .then(callback.bind(this))
      .catch(this.logout);
  }

  _handleSessionExpiration(event) {
    if (this.state.sessionRefreshToken == null) {
      this.logout();
      return;
    }

    let callback = function(response) {
      this.login(this.state.userName, 
        response['access_token'], 
        Date.now() + (response['expires_in'] * 100) - SESSION_REFRESH_CHECK_OFFSET, 
        response['refresh_token']);
    };

    this._tokenClient.refreshToken(this.state.sessionRefreshToken)
      .then(callback.bind(this))
      .catch(this.logout);
  }

  render() {
    return(
      <div className={ this.props.className }>
        <ul className={ this.props.className }>
          <li>
            <a style={ { backgroundColor: 'transparent' } }>
              <i className="zmdi zmdi-account"></i>
              <span> { this.state.userName } </span>
            </a>
          </li>
          <li hidden={ !this.state.logged }>
            <a style={ { backgroundColor: 'transparent' } }>
              <i className="zmdi zmdi-time-countdown"></i>
              <Countdown date={ this.state.sessionExpirationDate } key={this.state.sessionExpirationDate} onComplete={ this._handleSessionExpiration }></Countdown>
            </a>
          </li>
          <li hidden={ this.state.logged }>
            <a onClick={ this._handleLoginClick }>
              <i className="zmdi zmdi-key"></i>
              <span>Login</span>
            </a>
          </li>
          <li hidden={ !this.state.logged }>
            <a onClick={ this._handleLogoutClick }>
              <i className="zmdi zmdi-close"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
        <LoginForm ref={ element => this._loginForm = element } onSubmit={ this._handleLoginFormSubmit }></LoginForm>
      </div>
    );
  }
}

export default SessionInfo;



// WEBPACK FOOTER //
// ./src/_components/session_info/SessionInfo.jsx